import { ComponentProps } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import { Textarea } from '@/components/core/textarea';

import { DefaultFormField, FormFieldProps } from './default-form-field';

export function TextareaFormField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  name,
  disabled,
  label,
  description,
  hideError,
  ...props
}: FormFieldProps<ComponentProps<typeof Textarea>, TFieldValues, TName>) {
  return (
    <DefaultFormField
      control={control}
      name={name}
      label={label}
      description={description}
      hideError={hideError}
      disabled={disabled}
      render={({ field }) => <Textarea {...field} value={field.value ?? ''} {...props} />}
    />
  );
}
